import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "gfu-navbar-item gfu-navbar-dropdown",
  "data-qa": "header-actions:CartBox"
}
const _hoisted_2 = { class: "_pos-r" }
const _hoisted_3 = {
  class: "gfu-balloon__top-title",
  "data-qa": "cart-box:ProjectName"
}
const _hoisted_4 = { class: "_flex _jc-sb" }
const _hoisted_5 = { "data-qa": "cart-box:Quantity" }
const _hoisted_6 = {
  key: 0,
  class: "gfu-balloon__actions _mb-3 _pt-0",
  "data-qa": "cart-box:ModifyText"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "_py-1" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "gfu-balloon__content-item-desc" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 1,
  class: "gfu-balloon__content-item _tac"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 2,
  class: "gfu-balloon__actions"
}
const _hoisted_18 = {
  key: 1,
  class: "_tac",
  "data-qa": "cart-box:EmptyText"
}
const _hoisted_19 = { class: "gfu-balloon__top-title" }
const _hoisted_20 = { class: "gfu-balloon__top-title" }
const _hoisted_21 = { "data-qa": "cart-box:ItemsQuantity" }
const _hoisted_22 = {
  class: "_tac",
  "data-qa": "cart-box:EmptyText"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_toggle_trigger = _resolveComponent("toggle-trigger")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_button = _resolveComponent("base-button")
  const _component_go_to_checkout = _resolveComponent("go-to-checkout")
  const _component_base_balloon = _resolveComponent("base-balloon")
  const _component_toggle_content = _resolveComponent("toggle-content")
  const _component_toggle_container = _resolveComponent("toggle-container")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_toggle_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_toggle_trigger, {
          tag: "button",
          class: "gfu-navbar-btn gfu-navbar-btn--narrow gfu-navbar-dropdown-pointer",
          "active-class": "is-visible",
          "container-full-screen-width": $options.isMobile,
          "aria-label": _ctx.Resources.Layout.CartBoxTriggerLabel,
          "data-qa": "header-actions:CartBoxButton"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_component_base_icon, {
                class: _normalizeClass({'gfu-header-shake': $data.isAddingToCart}),
                size: "lg",
                name: "shopping-cart",
                "data-qa": "header-actions:ShoppingCart"
              }, null, 8 /* PROPS */, ["class"]),
              ($options.unpaidTotalQuantity > 0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(['gfu-cart-badge', { 'gfu-cart-badge--big': $data.isAddingToCart }]),
                    "data-qa": "cart-box:QuantityBadge"
                  }, _toDisplayString($options.unpaidItemsCount), 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["container-full-screen-width", "aria-label"]),
        _createVNode(_component_toggle_content, {
          class: "gfu-navbar-dropdown__content",
          "active-class": "is-visible",
          tabindex: "0"
        }, {
          default: _withCtx(() => [
            ($options.isCartAvailable)
              ? (_openBlock(), _createBlock(_component_base_balloon, {
                  key: "single",
                  width: "wide",
                  position: "right",
                  "is-pointer-visible": false,
                  "data-qa": "header-actions:CartBoxBalloon"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, _toDisplayString($options.model.cart.project.name), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Layout.CartBoxTotalItemsQuantity, $options.totalQuantity)), 1 /* TEXT */),
                      _createTextVNode(" " + _toDisplayString(_ctx.$format($options.totalPriceConverted, 'C2', $options.model.cart.currencySymbol)), 1 /* TEXT */)
                    ])
                  ]),
                  content: _withCtx(() => [
                    (!$options.pledgeIsEmpty)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          ($options.model.cart.parentOrder)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Layout.CartBoxModifyText, $options.orderPublicID)), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.displayedItems, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.orderItemID,
                              class: "_flex _gap-3"
                            }, [
                              _createElementVNode("a", {
                                href: $options.model.cartDetailsUrl,
                                class: "_flex"
                              }, [
                                _createVNode(_component_base_image, {
                                  src: item.imageUrl,
                                  width: "48",
                                  height: "48",
                                  loading: "lazy",
                                  alt: item.displayName
                                }, null, 8 /* PROPS */, ["src", "alt"])
                              ], 8 /* PROPS */, _hoisted_7),
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("a", {
                                  href: $options.model.cartDetailsUrl,
                                  class: "gfu-balloon__content-item-title"
                                }, _toDisplayString(item.displayName), 9 /* TEXT, PROPS */, _hoisted_9),
                                _createElementVNode("div", _hoisted_10, [
                                  _createTextVNode(_toDisplayString(_ctx.Resources.format(_ctx.Resources.Layout.CartBoxItemQuantity, item.quantity)) + " ", 1 /* TEXT */),
                                  (item.options.length > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, index) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: option.productOptionID
                                          }, [
                                            (index === 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "("))
                                              : _createCommentVNode("v-if", true),
                                            _createElementVNode("span", null, _toDisplayString(option.valueText), 1 /* TEXT */),
                                            (index + 1 < item.options.length)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, ", "))
                                              : _createCommentVNode("v-if", true),
                                            (index + 1 === item.options.length)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, ")"))
                                              : _createCommentVNode("v-if", true)
                                          ]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          ($options.model.productOrderItems.length > 5)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("a", {
                                  href: $options.model.cartDetailsUrl,
                                  class: "gfu-link gfu-link--accent"
                                }, _toDisplayString(_ctx.Resources.Layout.CartBoxViewAllButton), 9 /* TEXT, PROPS */, _hoisted_16)
                              ]))
                            : _createCommentVNode("v-if", true),
                          ($options.model.productOrderItems.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                (!$options.isYourPledgePage)
                                  ? (_openBlock(), _createBlock(_component_base_button, {
                                      key: 0,
                                      tag: "a",
                                      href: $options.model.cartDetailsUrl,
                                      theme: "primary",
                                      width: "compact",
                                      shape: "soft",
                                      "data-qa": "header-actions:ViewCart"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.Resources.Layout.CartBoxViewCartButton), 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["href"]))
                                  : _createCommentVNode("v-if", true),
                                ($options.isUnfinishedOrder)
                                  ? (_openBlock(), _createBlock(_component_go_to_checkout, {
                                      key: 1,
                                      "continue-url": $options.model.checkoutUrl
                                    }, {
                                      default: _withCtx(({ onInvoke }) => [
                                        _createVNode(_component_base_button, {
                                          tag: "a",
                                          href: $options.model.checkoutUrl,
                                          theme: "accent",
                                          width: "compact",
                                          shape: "soft",
                                          onClick: _withModifiers(onInvoke, ["stop","prevent"]),
                                          "data-qa": "header-actions:CheckOut"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.Resources.Layout.CartBoxCheckoutButton), 1 /* TEXT */)
                                          ]),
                                          _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["href", "onClick"])
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["continue-url"]))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.Resources.Layout.CartBoxEmptyPledge), 1 /* TEXT */))
                  ]),
                  _: 1 /* STABLE */
                }))
              : ($options.hasMultipleCarts)
                ? (_openBlock(), _createBlock(_component_base_balloon, {
                    key: "multiple",
                    "is-pointer-visible": false,
                    position: "right"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.Resources.Layout.CartBoxMultiplePledgesTitle), 1 /* TEXT */),
                      _createElementVNode("div", null, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Layout.CartBoxMultiplePledgesText, $options.model.projectsCount)), 1 /* TEXT */)
                    ]),
                    actions: _withCtx(() => [
                      _createVNode(_component_base_button, {
                        tag: "a",
                        href: $options.model.cartDetailsUrl,
                        theme: "primary",
                        width: "compact",
                        shape: "soft"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Resources.Layout.CartBoxViewPledgesButton), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["href"])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : (_openBlock(), _createBlock(_component_base_balloon, {
                    key: "empty",
                    "is-pointer-visible": false,
                    position: "right"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.Resources.Layout.CartBoxNoPledgesTitle), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Layout.CartBoxTotalItemsQuantity, 0)), 1 /* TEXT */)
                    ]),
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.Resources.Layout.CartBoxEmptyPledge), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ]))
}